const getPrescriberCity = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  if (prescriber && prescriber['Address Information']) {
    const address = prescriber['Address Information'];
    if (address.City) {
      return address.City.toUpperCase();
    }
    return null;
  }
  if (patient.Prescriber[0]) {
    const address = patient.Prescriber[0]['Address Information'];
    if (address.City) {
      return address.City.toUpperCase();
    }
    return null;
  }
  return null;
};

export default getPrescriberCity;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberCity.js